import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import Inscription from 'app/core/models/inscription';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InscriptionService {

  private uri: any = environment.protocol + '://' + environment.hostName;

  constructor(
    private http: HttpClient
  ) { }

  addInscription(data: any) {
    return this.http.post(`${this.uri}/inscription/add`, data);
  }
  editInscription(data: any) {
    return this.http.post(`${this.uri}/inscription/edit`, data);
  }
  getInscriptions(data: any) {
    return this.http.post(`${this.uri}/inscription/get/all`, data);
  }
  getInscriptionsByNumero(data: any) {
    return this.http.post(`${this.uri}/inscription/get/by/numero`, data);
  }
  getInscriptionsScanned(): Observable<any[]> {
    return this.http.get<any[]>(`${this.uri}/inscription/get/all/scanned`);
  }
  getInscription(id): Observable<any> {
    return this.http.get<any>(`${this.uri}/inscription/edit/${id}`);
  }
  deleteInscription(data: any): Observable<any> {
    return this.http.post(`${this.uri}/inscription/delete`, data);
  }
  cancelInscription(data: any): Observable<any> {
    return this.http.post(`${this.uri}/inscription/cancel`, data);
  }
  discancelInscription(data: any): Observable<any> {
    return this.http.post(`${this.uri}/inscription/discancel`, data);
  }
  scanInscription(data: any): Observable<any> {
    return this.http.post(`${this.uri}/inscription/scan`, data);
  }
  unScanInscription(data: any): Observable<any> {
    return this.http.post(`${this.uri}/inscription/unscan`, data);
  }
  uploadInvitation(data: any) {
    return this.http.post(`${this.uri}/inscription/upload`, data);
  }
  sendMailingInvitation(data: any) {
    return this.http.post(`${this.uri}/inscription/send/onemailing`, data);
  }
  sendMailingInvitations(): Observable<any> {
    return this.http.get<any>(`${this.uri}/inscription/send/allmailing`);
  }
  sendMailingErros(): Observable<any> {
    return this.http.get<any>(`${this.uri}/inscription/send/erros`);
  }
  deleteJustificatif(data: any) {
    const sendData = {
      fichier: data
    };
    return this.http.post(`${this.uri}/inscription/file/delete`, sendData);
  }
  viewPJ(data) {
    return this.http.get(`${this.uri}/inscription/file/view/${data}`);
  }
  addPaiement(data: any): Observable<any> {
    return this.http.post(`${this.uri}/inscription/paiement/add`, data);
  }
  getPaiementsByNumero(data: any) {
    return this.http.post(`${this.uri}/inscription/paiement/get/all/numero`, data);
  }
  cancelPaiement(data: any): Observable<any> {
    return this.http.post(`${this.uri}/inscription/paiement/cancel`, data);
  }
  getPaiementByNumero(data: any): Observable<any> {
    return this.http.post<any>(`${this.uri}/inscription/paiement/get/numero`, data);
  }
  getNbPreInscriptions() {
    return this.http.get(`${this.uri}/inscription/get/nbpreinscriptions`);
  }
  getNbPreInscriptionsTotal() {
    return this.http.get(`${this.uri}/inscription/get/nbpreinscriptionstotal`);
  }

}
